import styled from "styled-components";
import chess from "../../../../public/image/WhyUs/Operational/mobile/chess.webp";

export const ExcellenceMobileComponent = styled.div`
  height: ${(props) => (props.secHeight ? props.secHeight : 0) + "px"};
  overflow: hidden;
  transition: 0.5s;
  margin-top: ${(props) => (props.secHeight > 0 ? "-7vh" : 0)};
  position: relative;
  background-color: #fff;

  p {
    margin: 0;
  }
  .excellencemob__header {
    position: relative;
    &--background {
      width: 100%;
    }
    &--container {
      position: relative;
      height: 400px;
      width: 100%;
      background-image: url(${chess.src});
      background-position: center center;
      background-size: cover;
      & > * {
        position: absolute;
        left: 50%;
        top: 55%;
        transform: translate(-50%, -50%);
        bottom: unset;
        right: unset;
      }

      &-text {
        font-family: coolvetica_rg;
        font-size: 6vw;
        color: #fff;
        text-align: center;
        line-height: 0.9;
        margin: auto;
        position: absolute;
        height: fit-content;
        width: 100%;
        z-index: 1;
        top: 58%;

        @media (min-width: 500px) {
          font-size: 4rem;
        }
      }
      &-img {
        width: 60%;
        display: block;
        margin: auto;
        position: absolute;
        @media (min-width: 500px) {
          width: 300px;
        }
      }
      &-img-2 {
        width: 38%;
        z-index: 1;

        @media (min-width: 500px) {
          width: 190px;
        }
      }
    }
  }
  .excellencemob__section-1 {
    margin-top: -8px;
  }
  .excellencemob__section {
    padding-bottom: 1rem;
    .excellencemob__section--header {
      position: relative;
      &-img {
        width: 92%;
        position: relative;
        display: block;
        z-index: 1;
        margin: auto;
        margin-top: 2px;
        @media (min-width: 768px) {
          width: 70%;
          margin-top: 0;
        }
      }
      &-text {
        position: absolute;
        color: #11112f;
        font-family: poppinsBold;
        font-size: 0.9375rem;
        top: 0;
        bottom: 0;
        left: 46%;
        margin: auto;
        z-index: 1;
        height: fit-content;
        @media (min-width: 768px) {
          font-size: 1.45rem;
        }
      }
      &-text2{
        @media (max-width: 480px) {
          left: 51%;
        }
      }
    }
    .excellencemob__Section--content {
      width: 85%;
      margin: auto;
      margin-top: 0.5rem;
      text-align: justify;
      font-family: poppinsRegular;
      font-size: 0.8125rem;
      color: #3c3c3b;
      @media (min-width: 768px) {
        width: 65%;
        font-size: 1.3333333333333rem;
      }
      span {
        font-family: poppinsBold;
      }
      &--blue {
        color: #11112f;
      }
    }
  }
`;
